'use strict';

var n=(e=>(e.GET="get",e.DELETE="delete",e.POST="post",e.PUT="put",e))(n||{});

exports.a = n;
